import React from "react";
import { Switch, Typography } from "@mui/material";
import classNames from "classnames";

interface Props {
  toggled: boolean;
  onToggle: (param: boolean) => void;
  show?: boolean;
  leftLabel?: string;
  rightLabel?: string;
  className?: string;
}

export const ToggleSwitch = ({toggled, onToggle, leftLabel, rightLabel, className, show}: Props) => {
  if (show === false) return null;

  return (
    <div className={classNames(
      "flex flex-row items-center",
      className
    )}>
      {leftLabel && <Typography>{leftLabel}</Typography>}
      <Switch
        checked={toggled}
        sx={{
          "&.MuiSwitch-root .Mui-checked": {
            color: "var(--button-color)",
          },
          "&.MuiSwitch-root .Mui-checked+.MuiSwitch-track": {
            backgroundColor: "var(--button-color)",
            opacity: "50%",
          },
        }}
        onChange={(e: React.ChangeEvent<HTMLInputElement>) =>
          onToggle(e.target.checked)
        }
      />
      {rightLabel && <Typography>{rightLabel}</Typography>}
    </div>
  );
}